'use strict';

angular.module('app')
  .service('Search', function ($location, $q, info, utils, Request, gettextCatalog, config, GTM) {
    var Search = {},
        _this = this,
        spCounter = 1,
        DOpromise = false;

    Search.getGroupsParams = function (group) {
      if(!info.parameters) {
        return false;
      }
      var data = _.map(info.parameters[utils.shopKind(group)]);
      
      _.each(data,function(val,key) {
        if (!val.parameters.length) {
          delete data[key];
        }

        if (val.parameters.length <= 3) {
          val.hideButton = true;u
        }
      });

      return data;
    }


    Search.getDiveOperators = function ($scope, filters) {
      var localCounter = spCounter,
          newFilters = _.clone(filters);

      if (DOpromise) { DOpromise.resolve(false) }

      if (newFilters.date_from){
        newFilters.from = moment(newFilters.date_from).format('YYYY-MM-DD');
      }
      if (newFilters.date_to) {
        newFilters.to = moment(newFilters.date_to).format('YYYY-MM-DD');
      }

      DOpromise = $q.defer();

      Request.get('search/dive-operators/',newFilters, false, DOpromise).then(function (res){
        if (localCounter === spCounter-1) {
            var markers = [];
            _.each(res.data.data, function (val) {
              if(val.point) {
                markers.push({
                  lat: val.point[1],
                  lng: val.point[0],
                  icon: config.mapIcons.withPrice,
                  info: val,
                  getMessageScope: function () { return $scope; },
                  message: '<div ng-include src=\'"templates/_infowindow.html"\'></div>',
                  compileMessage: true,
                  autoPan: false
                });
              }
            });

            DOpromise.resolve({
              markers: markers,
              results: res.data
            });
          } else {
            DOpromise.reject('data is no more actual');
          }
      });

      spCounter += 1;

      return DOpromise.promise;
    }

    Search.getCoords = function (slug, kind) {
      return Request.get('search/geodata/' + slug + '/').then(function(coords) {
        var location;
        
        if (!_.isEmpty(coords.data.geometry)) {
          location = [
            {
              lat: coords.data.geometry.northeast.lat,
              lng: coords.data.geometry.northeast.lng
            },
            {
              lat: coords.data.geometry.southwest.lat,
              lng: coords.data.geometry.southwest.lng
            }
          ];
        }
        console.log(coords)
        return location;
      });
    }

    Search.getDiveSites = function ($scope, filters, template) {
      var newFilters = _.clone(filters);

      if (newFilters.date_from){
        newFilters.from = moment(newFilters.date_from).format('YYYY-MM-DD');
      }
      if (newFilters.date_to) {
        newFilters.to = moment(newFilters.date_to).format('YYYY-MM-DD');
      }

      var localCounter = spCounter,
          d = $q.defer();
          
      Request.get('search/dive-sites/', newFilters).then(function (res){
        if (localCounter === spCounter-1) {
          var markers = [];

          _.each(res.data, function (val) {
            if(val.point) {
              markers.push({
                lat: val.point[1],
                lng: val.point[0],
                icon: config.mapIcons.diveSites,
                info: {
                  slug: val.slug,
                  area: val.area,
                  country: val.country,
                  title: val.title,
                  rating: val.rating,
                  thumbnails: val.thumbnails,
                  diveSiteType: true,
                  kind: 30
                },
                autoPan: false,
                getMessageScope: function () { return $scope; },
                message: template ? '<div ng-include src=\'"templates/_ds-popup.html"\'></div>' : '<div ng-include src=\'"templates/_infowindow.html"\'></div>',
                compileMessage: true
              });
            }
          });

          d.resolve({
            markers: markers,
            results: res.data
          });
        } else {
          d.reject('data is no more actual Ds');
        }
      });


      spCounter += 1;

      return d.promise;
    }

    Search.closedTo = function(slug,type,center,leftBound,rightBound) {
      return Request.get('search/filter-autosuggest/',{q:slug, type:type,center: center, leftBound: leftBound, rightBound: rightBound}).then(function (res) {
        return res.data;
      });
    }

    Search.getHarbours = function($scope, filters) {
      var newFilters = _.clone(filters);

      if (newFilters.date_from){
        newFilters.from = moment(newFilters.date_from).format('YYYY-MM-DD');
      }
      if (newFilters.date_to) {
        newFilters.to = moment(newFilters.date_to).format('YYYY-MM-DD');
      }

      return Request.get('search/harbours/', newFilters).then(function(res){
        var markers = [];
        _.each(res.data, function (val) {
          if(val.point.length) {
            markers.push({
              lat: val.point[1],
              lng: val.point[0],
              icon: config.mapIcons.withPrice,
              info: {
                id: val.pk,
                title: val.title,
                slug: val.slug,
                type: 'harbour'
              },
              autoPan: false,
              getMessageScope: function () { return $scope; },
              message: '<div ng-include src=\'"templates/_harbour-popup.html"\'></div>'
            });
          }
        })
        return markers;
      });
    }

    Search.newSearch = function (model, type) {
       if(model.modelType === 'Shop') {
        var url = '',
            type,
            location = model.area;
        if (model.kind == 0) {
          GTM.event('search_dive_center');
          // url += '/dive-center';
        } else if (model.kind == 10) {
          GTM.event('search_liveaboard');
          // url += '/liveaboard';
          type = 'la_page'
          location = model.country;
        } else if (model.kind == 20) {
          GTM.event('search_dive_resort');
          // url += '/dive-resort';
          type = 'dr_page'
        } else if (model.kind === 30) {
          GTM.event('search_dive_site');
          // url += '/dive-sites';
        }

        url = utils.createURL(type, { location: location, slug: model.slug });

      } else if (model.modelType === 'Travel guides') {
        url = utils.createURL('destination', { location: model.slug });
      } else {
        GTM.event('search_destination');

        if(model.kind) {
          if (model.kind == 0) {
            type = 'dive-centers';
          } else if (model.kind == 10) {
            type = 'search_la';
          } else if (model.kind == 20) {
            type = 'search_dr';
          } else if (model.kind === 30) {
            type = 'dive-sites';
          }
        }
        
        url = utils.createURL(type, { slug: model.slug})
      }
      $location.path(url).hash('');
    }

    Search.generateUrl = function(object) {
      var link = '',
          area = object.area || object.areaSlug;

      if (object.kind == 10) {
        area = object.country || object.countrySlug;
      }

      if (object.hasOwnProperty('diveSiteType')) {
        link = 'dive-site';
      } else {
        link = Search.getShopKindName(object.kind);
      }

      return { location: area, slug: object.slug };
    }

    Search.priceType = function(kind) {
      if (kind == 0) {
          return gettextCatalog.getString('Per dive');
      } else if (kind == 10) {
          return gettextCatalog.getString('Per trip');
      } else if (kind == 20) {
          return gettextCatalog.getString('Per room');
      }
    }

    Search.operatorType = function(kind) {
      if (kind == 0) {
        return gettextCatalog.getString('Dive center');
      } else if (kind == 10) {
          return gettextCatalog.getString('Liveaboard');
      } else if (kind == 20) {
          return gettextCatalog.getString('Dive resort');
      } else if (kind == 30) {
          return gettextCatalog.getString('Dive sites');
      }
    };

    Search.getShopKindName = function(kind) {
      if (kind == 0) {
        return 'dive-center';
      } else if (kind == 10) {
        return 'liveaboard';
      } else if (kind == 20) {
        return 'dive-resort';
      } else if (kind == 30) {
        return 'dive-sites';
      }
    };

    Search.generatePageNumbers = function (numPerPage, totalElements, currentPage) {
      var text = '';
      if (currentPage * numPerPage > totalElements) {
        var qty = totalElements - numPerPage;
        text =  (qty >= 0 ? qty : 0) + 1 + ' - ' + totalElements;
      } else {
        var qty = currentPage * numPerPage;
        text = qty - numPerPage + 1 + ' - ' + qty;
      }

      return text + ' ' + gettextCatalog.getString('of') + ' ' + totalElements + ' ' + gettextCatalog.getString('results');
    }

    Search.togglePins = function (data, result, hideWindow, $scope) {
      _.each(data,function (val, index) {
        if (val.info.slug == result.slug) {
          if (!hideWindow) {
            val.focus = true;
          }

          if (val.icon.iconUrl == config.mapIcons.withPrice.iconUrl) {
            val.icon = config.mapIcons.markerViolet;
            val.zIndexOffset = 10;
          }
        } else {
          if (val.icon.iconUrl == config.mapIcons.markerViolet.iconUrl) {
            val.icon = config.mapIcons.withPrice;
            val.zIndexOffset = 1;
            val.focus = false;
          }
        }
      });

      return data;
    }

    Search.toggleHarbours = function (data, result, map, $scope) {
      var highlited = [];
      map.closePopup();

        _.each(data, function (val, index) {
          if (_.find(result.harbours, function(n) { return val.info.id == n})) {
            map.removeLayer($scope.circleArr[index]);

            $scope.circleArr[index] = L.circle([val.lat, val.lng], 200000, {
              color: '#ff5335',
              fillColor: '#ff5335',
              opacity: 0.7,
              fillOpacity: 0.7,
              weight: 1
            }).addTo(map);
          } else {
            map.removeLayer($scope.circleArr[index]);

            $scope.circleArr[index] = L.circle([val.lat, val.lng], 200000, {
              color: '#ff5335',
              fillColor: '#ff5335',
              opacity: 0.3,
              fillOpacity: 0.2,
              weight: 1
            }).addTo(map);
          }
      });
    }

    return Search;
  });
